import { setSlotFolderPickAction } from 'editor/src/store/app/slice';
import refreshCollectionCacheOperation from 'editor/src/store/collections/operations/refreshCollectionCacheOperation';
import type { Thunk } from 'editor/src/store/hooks';

/** The host's file library closed. A builder that asked for a folder and got none stops
 *  waiting, so a folder added from elsewhere later goes to the page. */
const libraryClosedOperation = (): Thunk => (dispatch) => {
  dispatch(refreshCollectionCacheOperation());
  dispatch(setSlotFolderPickAction(undefined));
};

export default libraryClosedOperation;
